import { defineNuxtPlugin } from "#app";
import { Locale } from "vant";
import enUS from "vant/es/locale/lang/en-US";
import deDE from "vant/es/locale/lang/de-DE";
import nlNL from "vant/es/locale/lang/nl-NL";
export default defineNuxtPlugin((nuxtApp) => {
  const path = nuxtApp.$router.currentRoute.value.path;
  if (path.startsWith("/en")) {
    Locale.use("en-US", enUS);
  } else if (path.startsWith("/nl")) {
    Locale.use("nl-NL", nlNL);
  } else if (path.startsWith("/cs")) {
    Locale.use("en-US", enUS);
  } else {
    Locale.use("de-DE", deDE);
  }
});
